export default __webpack_public_path__ + "static/TSSC_PNG-91d63cb0cd863d189f0cd9718d467185.png";